import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";
import { header } from "../../../styles/variables";

export interface CellarBottleHolderProps {
  baseColor: string;
  smUpHidden?: boolean;
}

export const CellarBottleHolder = styled.div<CellarBottleHolderProps>`
  ${breakpoints.smUp} {
    ${(props) => props.smUpHidden && `display: none;`}
    left: 0;
    top: ${header.mobileHeight};
  }
  ${breakpoints.mdUp} {
    top: ${header.desktopHeight};
  }
  background-color: ${(props) => props.baseColor};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 250px;
  &:after {
    content: "";
    padding-bottom: 60%;
    display: block;
    ${breakpoints.smDown} {
      padding-bottom: 56%;
    }
  }
`;

export default CellarBottleHolder;
